import styled from '@emotion/styled';

export const ControlSelect = styled.div`
    display: flex;
    position: relative;
`;
